"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdminPrompt = void 0;

var _Promptable = _interopRequireDefault(require("UIComponents/decorators/Promptable"));

var _AdminModal = _interopRequireDefault(require("ui-addon-upgrades/_core/common/components/AdminModal"));

var _PromiseHandlers = require("UIComponents/core/PromiseHandlers");

var _prompt = (0, _Promptable.default)(_AdminModal.default);

var AdminPrompt = function AdminPrompt(propsToPass) {
  return _prompt(propsToPass).catch(_PromiseHandlers.rethrowError);
};

exports.AdminPrompt = AdminPrompt;